module.exports = "<example-shell\n  exampleId=\"responsive-wrap\" [title]=\"title\" [summary]=\"summary\" [dataSnippet]=\"dataSnippet\" [events]=\"events\" (clear)=\"clearEvents()\">\n  <stackline-data-table\n    title=\"Responsive wrapped content\"\n    [columns]=\"wrappedColumns\"\n    [data]=\"longTextRows\"\n    [responsive]=\"true\"\n    [highlightOnHover]=\"true\">\n  </stackline-data-table>\n</example-shell>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/responsive-wrap/responsive-wrap.component.html
// module id = ./src/app/examples/responsive-wrap/responsive-wrap.component.html
// module chunks = main